import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import CustomButton from '../Button/Button';

const styles = theme => ({
    buttonSection: {
        display: 'flex',
        padding: '14px',
    },
    buttonLeft: {
        marginLeft: 'auto'
    },
    buttonRight: {
        marginLeft: '15px'
    },
});


const ActionButtons = (props) => {
    const { classes, submit, disabledSubmit, cancel, submitText = 'OK', cancelText = 'Cancel', cancelColor = 'secondary', colorSubmit = 'primary', size = 'medium'  } = props;
    return (
        <div className={classes.buttonSection}>
            <CustomButton disabled={disabledSubmit} onClick={submit} className={classes.buttonLeft} variant="contained" color={colorSubmit} size={size}>
                {submitText}
            </CustomButton>
            <CustomButton onClick={cancel} className={classes.buttonRight} variant="contained" color={cancelColor} size={size}>
                {cancelText}
            </CustomButton>
        </div>
    )
}
export default withStyles(styles)(ActionButtons);